export const ROLE_TYPE_ABBREVIATION_TO_VALUE_US = {
  SI: 'Stand-in',
  PD: 'Photo Double',
  SA: 'Special Ability',
  FBG: 'Featured Background',
  BG: 'Background',
} as const;

export const ROLE_TYPE_VALUES_US = Object.values(
  ROLE_TYPE_ABBREVIATION_TO_VALUE_US
);

export type RoleTypeValueUsType = typeof ROLE_TYPE_VALUES_US[number];

export const ROLE_TYPE_SORT_ORDER_MAP = {
  [ROLE_TYPE_ABBREVIATION_TO_VALUE_US.BG]: 1,
  [ROLE_TYPE_ABBREVIATION_TO_VALUE_US.FBG]: 2,
  [ROLE_TYPE_ABBREVIATION_TO_VALUE_US.SA]: 3,
  [ROLE_TYPE_ABBREVIATION_TO_VALUE_US.PD]: 4,
  [ROLE_TYPE_ABBREVIATION_TO_VALUE_US.SI]: 5,

  // uk options
  'Background Artist': 6,
  'Body Double': 7,
  Double: 8,
  'Featured Artist': 9,
  'Picture Double': 10,
  'Stand In': 11,
  'Supporting Artist': 12,
  'Walk On Artist': 13,
};
